module.exports = __webpack_public_path__ + "img/3.5d6a815f.jpg";